export default __webpack_public_path__ + "static/media/Testimonial1.17a48f16.png";